var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_CUSTOMERS = 'api/customer';
const GET_SET_CUSTOMERS_APP = 'api/v2/washdayapp/customers';
// export const bulkUpdate = async function (this: WashdayClientInstance, storeId: string, data: any): Promise<any> {
//   try {
//     const config = {
//       headers: { Authorization: `Bearer ${this.apiToken}`, 'Content-Type': false }
//     };
//     const response = await this.axiosInstance.put(`${GET_SET_PRODUCTS}/${storeId}/bulk`, data, config);
//     return response.data || {}
//   } catch (error) {
//     console.error('Error fetching getStoreById:', error);
//     throw error;
//   }
// };
export const updateById = function (id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_CUSTOMERS}/${id}`, data, config);
        }
        catch (error) {
            console.error('Error fetching updateById:', error);
            throw error;
        }
    });
};
export const updateByIdCustomersApp = function (id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_CUSTOMERS_APP}/${id}`, data, config);
        }
        catch (error) {
            console.error('Error fetching updateByIdCustomersApp:', error);
            throw error;
        }
    });
};
